var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9999 27.7847C48.08 37.0102 40.842 45.697 30.6858 47.638C25.7325 48.586 20.5942 48.008 16.0026 45.9863C11.4109 43.9645 7.60005 40.602 5.11255 36.3777C2.62504 32.1533 1.58773 27.2825 2.1483 22.4586C2.70888 17.6347 4.83876 13.1037 8.23469 9.51085C15.2 2.13783 26.9613 0.10822 36.5607 3.79842",
    stroke: "#20AE5C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3618 24.0943L26.9612 33.3198L49.9999 9.3335",
    stroke: "#20AE5C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessModalIcon);
export default __webpack_public_path__ + "static/media/SuccessModalIcon.487805532b7d94865c4291b5aa266015.svg";
export { ForwardRef as ReactComponent };